module.exports = __webpack_public_path__ + "img/ranger.70241e5a.png";